import { useState, useEffect } from 'react';

// True when the primary pointer is a finger rather than a mouse.
//
// Deliberately NOT a width check. A touchscreen laptop or an iPad in landscape
// reports a desktop-class viewport but still needs finger-sized hit tolerances
// and finger-shaped gestures, and a narrow desktop window needs neither. Width
// answers "how should this be laid out"; pointer type answers "how will this be
// touched". Callers that need the former should keep using innerWidth (see
// Layout.js) — this hook is only for gesture and hit-target decisions.
export function useCoarsePointer() {
    const [coarse, setCoarse] = useState(() => (
        typeof window !== 'undefined' && typeof window.matchMedia === 'function'
            ? window.matchMedia('(pointer: coarse)').matches
            : false
    ));

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        const query = window.matchMedia('(pointer: coarse)');
        const onChange = (event) => setCoarse(event.matches);

        // Safari only gained addEventListener on MediaQueryList in 14; the
        // deprecated addListener is the fallback for older iOS.
        if (typeof query.addEventListener === 'function') {
            query.addEventListener('change', onChange);
            return () => query.removeEventListener('change', onChange);
        }
        query.addListener(onChange);
        return () => query.removeListener(onChange);
    }, []);

    return coarse;
}

export default useCoarsePointer;
